<template>
  <Teleport to="body">
    <!-- Session Timeout Warning Modal -->
    <Transition name="fade">
      <div
        v-if="showTimeoutWarning"
        class="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999]"
      >
        <div class="bg-white rounded-2xl p-6 max-w-md mx-4 shadow-2xl">
          <div class="text-center">
            <div class="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>

            <h3 class="text-xl font-bold text-gray-900 mb-2">
              Sesion por expirar
            </h3>

            <p class="text-gray-600 mb-4">
              Tu sesion expirara en <span class="font-bold text-red-600">{{ formatTimeRemaining() }}</span> por inactividad.
            </p>

            <div class="flex space-x-3">
              <button
                @click="extendSession"
                class="flex-1 bg-indigo-600 text-white py-2.5 px-4 rounded-lg font-medium hover:bg-indigo-700 transition"
              >
                Continuar sesion
              </button>
              <button
                @click="handleLogout"
                class="flex-1 bg-gray-200 text-gray-700 py-2.5 px-4 rounded-lg font-medium hover:bg-gray-300 transition"
              >
                Cerrar sesion
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Demo Mode Indicator -->
    <Transition name="slide-up">
      <div
        v-if="isDemoUser && isAuthenticated"
        class="fixed bottom-4 left-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-4 py-2 rounded-lg shadow-lg z-50 flex items-center space-x-3"
      >
        <div class="flex items-center space-x-2">
          <div class="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
          <span class="text-sm font-medium">Modo Demo</span>
        </div>
        <div class="text-xs bg-white/20 px-2 py-1 rounded">
          {{ formatTimeRemaining() }}
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useDemoMode } from '@/composables/useDemoMode'

const router = useRouter()
const authStore = useAuthStore()

const {
  isDemoUser,
  showTimeoutWarning,
  formatTimeRemaining,
  extendSession,
  startSessionMonitoring
} = useDemoMode()

const isAuthenticated = computed(() => authStore.isAuthenticated)

function handleLogout() {
  localStorage.removeItem('demo_mode')
  localStorage.removeItem('demo_login_time')
  authStore.logout()
  router.push({ name: 'login' })
}

onMounted(() => {
  if (isAuthenticated.value) {
    startSessionMonitoring()
  }
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
